import { Component } from "preact";
import { numberWithCommas } from "../../../../utils/utility";
import style from "./style";

export default class DefaultAmountInput extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render({ inputValue }) {
    return (
      <div className={`${style.clear} ${style["pos-r"]}`}>
        <div className={`${style["amt-label"]} ${style.ibl}`}>Amount</div>
        <div className={`${style["amt-label"]} ${style.ibl} ${style.tr}`}>
          <span className={`${style["rupee-sign"]}`}>&#x20b9;</span>
          {numberWithCommas(inputValue)}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./form/components/inputs/default-amount/index.js